import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import tw from "twin.macro"

const LinkExternal = tw.a`cursor-pointer text-ql-blue hover:text-ql-bluelight focus:text-ql-bluelight font-bold tracking-wide`
const LinkInternal = tw(
  Link
)`cursor-pointer text-ql-blue hover:text-ql-bluelight focus:text-ql-bluelight font-bold tracking-wide`

const AppLink = ({ to, children, ...rest }) => {
  const LinkComponent = to ? LinkInternal : LinkExternal
  return (
    <LinkComponent {...rest} to={to}>
      {children}
    </LinkComponent>
  )
}

AppLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node
}

export default AppLink
